import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { usePageTypeContent } from "../../hooks/UseContentHook";
import { GasMainsRelocationPage, GasMainsRelocationPageProps } from "./GasMainsRelocationPage";

export const EMPTY_PAGE_CONTENT: GasMainsRelocationPageProps = {
  pageTitle: "",
};

export const CANONICAL_LINK = "/personal/gas/gas-main-relocation";

export const GasMainsRelocationPageContainer: React.FC<RouteComponentProps> = routeProps => {
  const { content } = usePageTypeContent<GasMainsRelocationPageProps>("gas_mains_relocations", EMPTY_PAGE_CONTENT);
  if (content.seo) {
    content.seo.canonicalLink = CANONICAL_LINK;
  }
  return <GasMainsRelocationPage {...routeProps} {...content} />;
};
